import { Button, Col, Row, Spin, message } from "antd";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import React, { Dispatch, SetStateAction, useState } from "react";
import { authAxios } from "../../../utils/session_utils";
import { BulkAddDataModal, VideoSearchItem } from "../../../custom-components";
import { Checkbox } from "antd/lib";
import { SearchOutlined } from "@ant-design/icons";
import { SelectedVideoData as selectedData } from "../../videos";

interface BulkVideosTaggingModalInterface {
	isBulkTaggingModalOpen: boolean;
	setIsBulkTaggingModalOpen: Dispatch<SetStateAction<boolean>>;
	tagsList: any[];
	selectedData: selectedData[];
	getDataHandler: (params: any) => void;
	tagEntityType: 'video' | 'episode';
}

const BulkVideosTaggingModal: React.FC<BulkVideosTaggingModalInterface> = ({
	isBulkTaggingModalOpen,
	setIsBulkTaggingModalOpen,
	tagsList,
	selectedData,
	getDataHandler,
	tagEntityType
}) => {
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [searchText, setSearchText] = useState<string>("");
	const [tagCheckedList, setTagCheckedList] = useState<string[]>([]);
	tagsList = tagsList.filter(tag => tag.related_to.includes("video"));
	const tagListPlainOptions = tagsList.map(list => ({
		value: list.id,
		label: list.name,
	}));
	const tagListIds = tagsList.map(list => list.id);
	const checkAll = tagListPlainOptions.length === tagCheckedList.length;
	const indeterminate =
		tagCheckedList.length > 0 && tagCheckedList.length < tagListPlainOptions.length;

	const tagListChange = (list: string[]) => {
		setTagCheckedList(list);
	};

	const onTagCheckAllChange = (e: CheckboxChangeEvent) => {
		setTagCheckedList(e.target.checked ? tagListIds : []);
	};

	const tagBulk = async () => {
		try {
			setIsLoading(true);
			const entityKey = tagEntityType === 'video' ? 'video_ids' : 'episodes_ids';
			const data = {
				[entityKey]: selectedData.map(item => item.id),
				tag_ids: tagCheckedList,
			};
			const config = {
				method: "POST",
				url: `${process.env.REACT_APP_BACK_END_API}/snowflake/bulk/${tagEntityType === 'episode' ? 'add-episode-tags' : 'add-video-tags'}`,
				data: JSON.stringify(data),
				headers: { "Content-Type": "application/json" },
			};
			const response = await authAxios(config);
			message.success(response.data.message);
			await getDataHandler({});
			setIsLoading(false);
			closeHandler();
		} catch (error) {
			setIsLoading(false);
			message.error(`Could not save ${tagEntityType === 'episode' ? 'episodes' : 'videos'} list`);
			console.error("error addBulkVideosToList", error);
		}
	};

	const untagBulk = async () => {
		try {
			setIsLoading(true);
			const entityKey = tagEntityType === 'video' ? 'video_ids' : 'episodes_ids';
			const data = {
				[entityKey]: selectedData.map(item => item.id),
				tag_ids: tagCheckedList,
			};
			const config = {
				method: "POST",
				url: `${process.env.REACT_APP_BACK_END_API}/snowflake/bulk/${tagEntityType === 'episode' ? 'remove-episode-tags' : 'remove-video-tags'}`,
				data: JSON.stringify(data),
				headers: { "Content-Type": "application/json" },
			};
			const response = await authAxios(config);
			message.success(response.data.message);
			await getDataHandler({});
			setIsLoading(false);
			closeHandler();
		} catch (error) {
			setIsLoading(false);
			message.error(`Selected ${tagEntityType === 'episode' ? 'episodes' : 'videos'} could not be removed from selected lists.`);
			console.error("error removeBulkVideosFromList", error);
		}
	};

	const closeHandler = () => {
		setIsBulkTaggingModalOpen(false);
		setTagCheckedList([]);
	};

	return (
		<BulkAddDataModal
			open={isBulkTaggingModalOpen}
			onCancel={closeHandler}
			title={`Add or Remove ${tagEntityType === 'episode' ? 'Episode' : 'Video'} Tag(s):`}
			centered
			footer={
				<>
					<Button onClick={untagBulk} disabled={!tagCheckedList?.length || isLoading} danger>
						Remove
					</Button>
					<Button
						onClick={tagBulk}
						disabled={!tagCheckedList?.length || isLoading}
						type="primary"
					>
						Add
					</Button>
				</>
			}
		>
			<Spin spinning={isLoading}>
				<VideoSearchItem
					placeholder="Search Tags"
					onChange={e => setSearchText(e.target.value)}
					suffix={<SearchOutlined />}
				/>
				{!searchText && (
					<Checkbox indeterminate={indeterminate} onChange={onTagCheckAllChange} checked={checkAll}>
						{checkAll ? "De-Select All" : "Select All"}
					</Checkbox>
				)}
				<Checkbox.Group onChange={tagListChange} value={tagCheckedList}>
					<Row gutter={[0, 4]}>
						{tagsList
							.filter(tag =>
								searchText ? tag.title.toLowerCase().includes(searchText?.toLowerCase()) : true
							)
							.map((tag: any) => {
								return (
									<Col span={24} key={tag.key}>
										<Checkbox value={tag.id} key={tag.key}>
											<b>{tag.title}</b>
										</Checkbox>
									</Col>
								);
							})}

						{/* {searchText?.trim()?.length ? (
							<CreateNewListCol onClick={createNewVideoList} span={24}>
								<span>
									<b>&quot;{searchText}&quot;</b>
								</span>{" "}
								&nbsp;
								<span>(Create new)</span>
							</CreateNewListCol>
						) : null} */}
					</Row>
				</Checkbox.Group>
			</Spin>
		</BulkAddDataModal>
	);
};

BulkVideosTaggingModal.displayName = "VideosTaggingModal";
export default BulkVideosTaggingModal;
